import { createSelector } from 'reselect';

const getHasLoaded = createSelector(
  (state) => state.findWordsStepTwoExtraLevels.hasLoaded,
  (hasLoaded) => hasLoaded
);
const getCurrencyData = createSelector(
  (state) => state.findWordsStepTwoExtraLevels.data.currency,
  (currency = {}) => currency
);
const getLevelsData = createSelector(
  (state) => state.findWordsStepTwoExtraLevels.data.findWordsStepTwoExtraLevels,
  (levels = []) => levels
);

export default {
  getCurrencyData,
  getHasLoaded,
  getLevelsData,
};
